import { render, staticRenderFns } from "./admin-messages.vue?vue&type=template&id=170b0e7c&scoped=true"
import script from "./admin-messages.vue?vue&type=script&lang=js"
export * from "./admin-messages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170b0e7c",
  null
  
)

export default component.exports